import { useEffect } from 'react';

import { Footer } from '@/components/Footer';

interface LegalPageLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalPageLayout({
  title,
  lastUpdated,
  children,
}: LegalPageLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2" style={{ color: '#1A1A1A' }}>
          {title}
        </h1>
        <p className="text-sm mb-6" style={{ color: '#8B8580' }}>
          Last Updated: {lastUpdated}
        </p>
        <hr className="mb-8" style={{ borderColor: '#E8E3DD' }} />
        <div className="legal-prose">{children}</div>
      </div>
      <Footer />

      <style>{`
        .legal-prose h2 {
          font-size: 1.375rem;
          font-weight: 700;
          color: #1A1A1A;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
        }
        .legal-prose h3 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #1A1A1A;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
        }
        .legal-prose p {
          color: #4A4A4A;
          line-height: 1.7;
          margin-bottom: 1rem;
        }
        .legal-prose ul,
        .legal-prose ol {
          color: #4A4A4A;
          line-height: 1.7;
          margin-bottom: 1rem;
          padding-left: 1.5rem;
        }
        .legal-prose ul {
          list-style-type: disc;
        }
        .legal-prose ol {
          list-style-type: lower-alpha;
        }
        .legal-prose li {
          margin-bottom: 0.5rem;
        }
        .legal-prose li ul,
        .legal-prose li ol {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
        }
        .legal-prose a {
          color: #8B2332;
          text-decoration: underline;
        }
        .legal-prose a:hover {
          color: #6B1A26;
        }
        .legal-prose strong {
          font-weight: 600;
          color: #1A1A1A;
        }
      `}</style>
    </>
  );
}
